import React, { useContext } from 'react';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { NavContext } from "../../../contexts";
import { ComuneCompetenzaContext } from '../ComuneCompetenzaContext';

import CloseIcon from '@mui/icons-material/Close';

import {
    Autocomplete,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TextField,
    Typography
} from '@mui/material';
import { Field, Formik } from 'formik';
import moment from 'moment';

export const AddEccezioneDialog = ({
    open,
    setOpen,
    disabled,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
    } = useContext(ComuneCompetenzaContext);

    const {
        uffici,
        ufficiOptions,

        ufficioComuneCompetenza,
    } = state;

    const handleClose = () => {
        setOpen(false);
    };

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <IconButton
                    aria-label="close"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                    }}
                    onClick={() => setOpen(false)}>
                    <CloseIcon />
                </IconButton>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    Nuova Eccezione
                </DialogTitle>
                <DialogContent>
                    <Formik
                        initialValues={
                            {
                                ufficioId: "",
                                ufficioComuneCompetenzaId: ufficioComuneCompetenza.id,
                                inizioValidita: moment.utc([1946, 5, 2]),
                                fineValidita: null,
                            }
                        }
                        enableReinitialize
                        onSubmit={handleOnSubmit}>
                        {({
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                            touched,
                            setTouched,
                        }) => {
                            return <form onSubmit={handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                                        <Field
                                            name="ufficioId"
                                            component={Autocomplete}
                                            options={ufficiOptions}
                                            onChange={(e, value) => {
                                                setFieldValue('ufficioId', value?.ufficioId)
                                            }}
                                            value={ufficiOptions.find(option => option.ufficioId == values.ufficioId) ?? null}
                                            renderInput={(params) => <TextField {...params} label="Ufficio" />}
                                            fullWidth
                                        />
                                        {
                                            errors.ufficioId &&
                                            <Typography color="error">
                                                {errors.ufficioId}
                                            </Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            name="inizioValidita"
                                            component={DatePicker}
                                            onChange={value => {
                                                if (value?.isValid)
                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                else
                                                    setFieldValue('inizioValidita', null);
                                            }}
                                            inputFormat="DD/MM/YYYY"
                                            minDate={moment.utc([1946, 5, 2])}
                                            value={values.inizioValidita}
                                            renderInput={(params) => <TextField {...params} label="Inizio validità" />}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            name="fineValidita"
                                            component={DatePicker}
                                            onChange={value => {
                                                if (value?.isValid)
                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                else
                                                    setFieldValue('fineValidita', null);
                                            }}
                                            inputFormat="DD/MM/YYYY"
                                            minDate={moment.utc([1946, 5, 2])}
                                            value={values.fineValidita}
                                            renderInput={(params) => <TextField {...params} label="Fine validità" />}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            color="info"
                                            disabled={disabled}
                                            type="submit">
                                            Salva
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        }}
                    </Formik>
                </DialogContent>
            </Dialog>
        </>
    );
}